import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import Raven from 'raven-js';
import RetakePracticalExerciseModal from './RetakePracticalExerciseModal';
import UsageTracker from '../../../utils/UsageTracker';
import { TrackingContentTypes } from '../../../constants/Tracking';
import { useDeletePracticalExerciseProgress } from '../practicalExerciseQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class PracticalExerciseRetryButtonContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayRetakeModal: false
    };
    this.handleRejectRetakePracticalExercise = this.handleRejectRetakePracticalExercise.bind(this);
    this.handleClickRetakeExercise = this.handleClickRetakeExercise.bind(this);
    this.handleConfirmRetakePracticalExercise = this.handleConfirmRetakePracticalExercise.bind(this);
  }
  handleClickRetakeExercise() {
    this.setState({
      displayRetakeModal: true
    });
  }
  handleRejectRetakePracticalExercise() {
    this.setState({
      displayRetakeModal: false
    });
  }
  handleConfirmRetakePracticalExercise() {
    const {
      trackId,
      lessonId,
      contentId
    } = this.props;
    this.setState({
      displayRetakeModal: false
    });
    UsageTracker.track('contentInteraction', {
      action: 'retry-practical-exercise',
      contentId,
      contentType: TrackingContentTypes.PRACTICAL_EXERCISE_FLOW,
      trackId,
      lessonId
    });
    this.props.onRetryPracticalExercise(Number(contentId));
  }
  render() {
    const {
      requiredAccess,
      requiredProduct,
      use
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [this.state.displayRetakeModal && /*#__PURE__*/_jsx(RetakePracticalExerciseModal, {
        onConfirm: this.handleConfirmRetakePracticalExercise,
        onReject: this.handleRejectRetakePracticalExercise
      }), /*#__PURE__*/_jsx(Tooltip, {
        disabled: !(requiredProduct || requiredAccess),
        headingText: requiredProduct ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.practicalExercise.requiredProduct.${requiredProduct}.header`
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.practicalExercise.requiredAccess.${requiredAccess}.header`
        }),
        title: requiredProduct ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.practicalExercise.requiredProduct.${requiredProduct}.description`
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.practicalExercise.requiredAccess.${requiredAccess}.description`
        }),
        children: /*#__PURE__*/_jsx(Button, {
          "data-test-id": "practical-exercise-retry-button",
          disabled: !!requiredProduct || !!requiredAccess,
          onClick: this.handleClickRetakeExercise,
          use: use,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.retake"
          })
        })
      })]
    });
  }
}
PracticalExerciseRetryButtonContainer.defaultProps = {
  use: 'secondary'
};
const PracticalExerciseRetryButtonFunctionalContainer = props => {
  const [deletePracticalExerciseProgress] = useDeletePracticalExerciseProgress();
  const handleOnRetryPracticalExercise = contentId => {
    deletePracticalExerciseProgress(contentId).catch(Raven.captureException.bind(Raven));
  };
  return /*#__PURE__*/_jsx(PracticalExerciseRetryButtonContainer, Object.assign({
    onRetryPracticalExercise: handleOnRetryPracticalExercise
  }, props));
};
export default PracticalExerciseRetryButtonFunctionalContainer;